<article class="ui-stepper-main-step">
  <span
    class="ui-stepper-main-step__status"
    [class]="'is-' + state"
    aria-hidden="true"
  >
    <span class="ui-stepper-main-step__status-inner" [class]="'is-' + state">
      <app-stepper-icon *ngIf="state === 'completed'" name="check" />
      <app-stepper-icon *ngIf="state === 'error'" name="close" />
      <span
        *ngIf="state !== 'completed' && state !== 'error'"
        class="ui-stepper-main-step__index"
      >
        {{ numericIndex }}
      </span>
    </span>
  </span>

  <div class="ui-stepper-main-step__title-wrap">
    <p class="ui-stepper-main-step__title">{{ step.label }}</p>
    <p class="ui-stepper-main-step__subtitle" *ngIf="step.subtitle">
      {{ step.subtitle }}
    </p>
  </div>

  <div class="ui-stepper-main-step__action" *ngIf="showAction">
    <ng-container *ngIf="hasCustomAction; else legacyActionButton">
      <ng-container
        *ngComponentOutlet="customActionComponent; inputs: customActionInputs"
      />
    </ng-container>
    <ng-template #legacyActionButton>
      <button
        class="ui-stepper-main-step__action-button"
        type="button"
        [class.icon-only]="!step.action?.label"
        [class.is-disabled]="step.action?.disabled"
        [style.color]="actionColor"
        [disabled]="step.action?.disabled"
        [ngbTooltip]="actionTooltip"
        [attr.aria-label]="actionAriaLabel"
        (click)="handleActionClick()"
      >
        <span
          class="ui-stepper-main-step__action-label"
          *ngIf="step.action?.label"
        >
          {{ step.action?.label }}
        </span>
        <ng-container
          *ngComponentOutlet="
            step.action?.icon;
            inputs: { height: '16px', width: '16px' }
          "
        />
      </button>
    </ng-template>
  </div>

  <span
    *ngIf="showConnector"
    class="ui-stepper-main-step__connector"
    [class.is-active]="connectorActive"
    aria-hidden="true"
  ></span>
</article>
